module.exports = __webpack_public_path__ + "media/images/web/twitter-fabc854c976c1aa24aa75182a9fe75c3.svg";